export default "__VITE_ASSET__1271e45c__"